export const TARGET_ACTIONS = [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-see-objetive"
  },
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "view-edit-objetive"
  },
  {
    icon: "el-icon-plus",
    label: "Tarea",
    command: "task-agregar-nueva",
    disabled: true
  },
  {
    icon: "el-icon-delete",
    label: "Eliminar",
    command: "view-edit-objetive-eliminar"
  }
];

export const HEADERS = [
  {
    prop: "Id",
    name: "No",
    width: 80,
    sortable: true
  },

  {
    sortable: true,
    prop: "Perspectiva",
    name: "Perspectiva"
  },
  {
    prop: "Name",
    name: "Descripcion"
  },
  {
    prop: "Deparment",
    name: "Departamento"
  },
  {
    prop: "Responsable",
    name: "Nombre del Responsable"
  },
  {
    prop: "dateinit",
    name: "Fecha de inicio"
  },
  {
    prop: "dateend",
    name: "Fecha Fin"
  },
  {
    prop: "priority",
    name: "Prioridad"
  },
  {
    prop: "status",
    name: "Estatus"
  }
];

export const TASK_ACTIONS = [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-task-view"
  },
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "view-task-edit"
  },
  {
    icon: "el-icon-delete",
    label: "Eliminar",
    command: "view-task-delete"
  },
  {
    icon: "el-icon-document",
    label: "Ver Evidencia",
    command: "view-task-evidence"
  }
];
